const state = () => ({
  isRadiusDrawOn: false
});

const mutations = {
  SET_RADIUS_DRAW_STATE(state, value) {
    state.isRadiusDrawOn = value;
  }
};

const actions = {
  toggleRadiusDrawState({ commit }, value) {
    commit('SET_RADIUS_DRAW_STATE', value);
  }
};

const getters = {
  isRadiusDrawOn: (state) => {
    return state.isRadiusDrawOn;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
